import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useDocumentImagesInfiniteQueryKey } from './useDocumentImagesInfiniteQueryKey'

export const useInvalidateDocumentImagesInfiniteQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useDocumentImagesInfiniteQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
